import {
  shiftTimeDisplayValues,
  type IScheduledShift,
} from "@medoma/models/shifts";
import { Text, type IText } from "@medoma/components/Text/Text";
import { useLingui } from "@lingui/react/macro";
import styles from "./ShiftTime.module.scss";
import clsx from "clsx";
import { TimeSpan } from "./TimeSpan";

type IShiftTime = { relativeToDate: Date } & Pick<
  IScheduledShift,
  "startDateTime" | "endDateTime"
> &
  Pick<IText, "size" | "color"> & {
    layout?: "horizontal" | "vertical";
  };

const ShiftTime = ({
  relativeToDate,
  startDateTime,
  endDateTime,
  size = "base",
  color,
  layout = "vertical",
}: IShiftTime) => {
  const { t } = useLingui();

  const {
    startedDayBefore,
    hasEndTimeAfterToday,
    formattedDayBefore,
    formattedDayToday,
  } = shiftTimeDisplayValues({
    selectedDate: relativeToDate,
    startDateTime,
    endDateTime,
  });

  const additionalContext = `${startedDayBefore ? t`Start ${formattedDayBefore}` : hasEndTimeAfterToday ? t`Start ${formattedDayToday}` : ""}`;
  const hasAdditionalContext = additionalContext !== "";

  return (
    <>
      <div className={clsx([styles.shiftTime, styles[`layout-${layout}`]])}>
        <TimeSpan
          timespan={{ start: startDateTime, end: endDateTime }}
          size={size}
          color={color}
        />
        {hasAdditionalContext ? (
          <Text
            element={layout === "vertical" ? "div" : "span"}
            color="faded"
            size={layout === "vertical" ? "small" : size}
          >
            {additionalContext}
          </Text>
        ) : null}
      </div>
    </>
  );
};

export { ShiftTime };
